import { render, staticRenderFns } from "./valueboundary.vue?vue&type=template&id=b2285244&"
import script from "./valueboundary.vue?vue&type=script&lang=js&"
export * from "./valueboundary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports